import { debounce } from '../../shared/debounce';
import { Field, MhElement } from '../../shared/interfaces';

export const email: Field = {
    feedback: true,
    setupValidation(element: MhElement) {
        const input = element.input as HTMLInputElement;
        const feedback = element.feedback as HTMLParagraphElement;

        const debounceFn = debounce(() => {
            if (!input.validity.valid) {
                feedback.innerHTML = `Fix the email.`;
                input.classList.add(`!border-red-500`);
                return;
            }

            feedback.innerHTML = `&nbsp;`;
            input.classList.remove(`!border-red-500`);
        });

        input.addEventListener(`input`, () => {
            debounceFn();
        });
    },
};
